// extracted by mini-css-extract-plugin
export default {"header":"Devices_header__YxvVp","content":"Devices_content__jV9PN"};